import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../BitsStyles/Carouselpage.css';
import logo from '../BitsImages/logoooo12345.jpg';

const Carouselpage = () => {
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [servicesDropdownActive, setServicesDropdownActive] = useState(false);

  return (
    <div className="bodyofcarousel">
      <nav className="nav-container">
        <div className="logo">
        <img src={logo} alt="atlantic" style={{width:'50px',height:'40px'}}/>  Bellary Info Tech</div>
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about-us">About us</Link>
          <div className="dropdown">
            <div className="dropdown-header">
              <Link to="/service-bits" className="dropbtn">
                Services
              </Link>
              <i
                className="dropdown-icon"
                style={{
                  marginLeft: '8px',
                  transform: 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              >
                ▼
              </i>
            </div>
            <div className="dropdown-content">
              <Link to="/billing" style={{fontWeight:'bold'}}>Billing Solutions</Link>
              <Link to="/service-bits" style={{fontWeight:'bold'}}>IT Services</Link>
              <Link to="/service-bits" style={{fontWeight:'bold'}}>Support Projects</Link>
            </div>
          </div>
          <Link to="/career-bits">Careers</Link>
          <Link to="/contact-bits">Contact us</Link>
        </div>
        <div className="hamburger" onClick={() => setMobileMenuActive(!mobileMenuActive)}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileMenuActive ? 'active' : ''}`}>
        <br />
        <br />
        <br />
        <Link to="/">Home</Link>
        <Link to="/about-us">About us</Link>
        <div className="mobile-services-dropdown">
          <div
            className="dropdown-header"
            onClick={() => setServicesDropdownActive(!servicesDropdownActive)}
          >
            <span>Services</span>
            <i
              className={`dropdown-icon ${servicesDropdownActive ? 'open' : ''}`}
              style={{
                marginLeft: '8px',
                transform: servicesDropdownActive ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }}
            >
              ▼
            </i>
          </div>
          <div
            className={`mobile-dropdown-content ${servicesDropdownActive ? 'active' : ''}`}
          >
            <Link to="/billing" style={{fontWeight:'bold'}}>Billing Solutions</Link>
            <Link to="/service-bits" style={{fontWeight:'bold'}}>IT Services</Link>
            <Link to="/service-bits" style={{fontWeight:'bold'}}>Support Projects</Link>
          </div>
        </div>
        <Link to="/career-bits">Careers</Link>
        <Link to="/contact-bits">Contact us</Link>
      </div>
      
    </div>
  );
};

export default Carouselpage;
